import { format } from 'date-fns/format';
import { ja } from 'date-fns/locale';
import { tz } from '@date-fns/tz/tz';

const tokyoTimeZone = tz('Asia/Tokyo');

/**
 * 日時を与えられたフォーマットに変換する関数。
 * @param date
 * @param formatStr
 * @returns
 */
export const formatDateTime = (
  date: string | Date,
  formatStr: string
): string => {
  const parsedDate = typeof date === 'string' ? new Date(date) : date;

  return format(parsedDate, formatStr, { locale: ja, in: tokyoTimeZone });
};
